var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nuxt-link',{staticClass:"page-header__logo",attrs:{"to":"/"}},[_c('div',{staticClass:"page-header__logo-img-wrap"},[_c('img',{staticClass:"page-header__logo-letters",attrs:{"src":require("assets/img/logo-black.svg"),"alt":"Портал проверенных автомобилей с пробегом — carro.ru","height":"156","width":"58"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }